import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

interface UploadSignatureParams {
  slug: string;
  visitReportId: number;
  signatureData: string;
  documentType: 'visit' | 'period' | 'digest';
}

export const uploadCustomerSignature = async ({
  slug,
  visitReportId,
  signatureData,
  documentType,
}: UploadSignatureParams) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const formData = new FormData();
  formData.append('customer_signature', dataURItoBlob(signatureData), `customerSignature_Visit-${visitReportId}.png`);

  const data = await axiosInterceptor.patch(
    `${process.env.REACT_APP_BASE_DJANGO_URL}/api/${documentType}_report/${slug}/${visitReportId}/add-customer-signature/`,
    formData,
    {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data.data as any;
};

const dataURItoBlob = (dataURI: string) => {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  return new Blob([arrayBuffer], { type: mimeString });
};
